<div class="flex items-center justify-center min-h-[72vh] flex-col">
    <h1 class="text-primary text-2xl font-bold text-center">
      <span class="animate-pulse">Permisos en mantenimiento</span>
      <span class="dots">
        <span class="dot animate-dot1">.</span>
        <span class="dot animate-dot2">.</span>
        <span class="dot animate-dot3">.</span>
      </span>
    </h1>
  </div>
